<script setup lang="ts">
import { getOptimizedImageSrc } from '@/directives/optimizedImageSize';
import { IImage } from '@/interfaces';

interface Props {
  pictures: IImage[] | string[];
}

withDefaults(defineProps<Props>(), {});

const emit = defineEmits(['picture-selected']);
</script>

<template>
  <div class="grid grid-cols-3 gap-5 object-cover">
    <div v-if="!pictures.length" class="header">
      <fa-icon
        class="text-neutral-300 text-6xl mb-3"
        :icon="['fas', 'fa-image']"
      />

      <p class="h700">{{ $t('media.noImages') }}</p>
    </div>

    <img
      v-for="(picture, index) in pictures"
      :key="index"
      :src="getOptimizedImageSrc(picture, 'medium')"
      class="object-cover h-[280px] w-full rounded-[20px]"
      @click="emit('picture-selected', index)"
    />
  </div>
</template>
